export default __webpack_public_path__ + "static/media/loader2.a82ca628.jpg";